module.exports = __webpack_public_path__ + "static/media/Sanat_Madan.855412a2.svg";